import VOGSection from "./VOGSection";

export default VOGSection;
